module.exports = __webpack_public_path__ + "img/sii-icon-active.3d59e173.svg";